import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Layout from "layouts/layout";
import { useLocation, useHistory } from "react-router-dom";
import Input from "components/input/input";
import Button from "components/button/button";
import { FaSearch, FaPlus, FaTimes } from "react-icons/fa";
import SearchItem from "components/search/search-item";
import AdvanceSearch from "components/search/advance-search";
import LoadMore from "components/pagination/load-more";
import { urlSerializer } from "utils/utils";
import { ProfileDefaultPlaceholder } from "constants/images";
import {
  REFRESH_SEARCH_PROFILE,
  GET_SEARCH_PROFILE,
  SET_SEARCH_PROFILE,
  SET_SORT_PROFILE
} from "redux/modules/search-profile/types";
import { gsap } from "gsap";
import PopInfo from "components/info-popup/pop-info";
import { EmptySearch } from "constants/images";
import { Link } from "react-router-dom";
import { randomExtension } from "utils/utils";
import { useTranslation } from "react-i18next";
import { useStates } from "redux/modules/states/hooks";
import Select from "components/select/select";
import { useWindowDimensions } from "utils/customhooks";


export default function Search() {
  const {t} = useTranslation();
  const { http } = global.services;
  const extension = randomExtension();
  const history = useHistory();
  const contentRef = useRef();
  const query = useQuery();
  const { isMobile } = useWindowDimensions();
  const searchValue = query.get("keyword");
  const [search, setSearch] = useState(searchValue);
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
  const [occupations, setOccupation] = useState([]);
  const [state, setState] = useState({
    name: "",
    job_role: "",
    city: "",
    state: "",
    country: "",
    gender: "",
    age:null,
    lang_id:null,
    location:"",
    profileTypes:"all",
    // sort:'asc'
  });
  const {
    page,
    refresh,
    loadMore,
    initialize,
    isRequesting,
    results = [],
    sort: sortType
  } = useSelector((state) => state.searchProfile);
  const [sort,setSort] = useState(sortType || 'asc');
  // const {
  //   userData
  // } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const userData = JSON.parse(localStorage.getItem('user_data'));

    const sortBy = [
      { label: "Alphabetical (A–Z)", value: "asc" },
      { label: "Alphabetical (Z–A)", value: "desc" },
    ]; 

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearch(value);
  };

  const {
      isAdvance,
      setIsAdvance
    } = useStates();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if(name === "age"){
      // let todayYear = new Date().getFullYear();
      if(value.min === 0 && value.max === 100){
        setState((prev) => ({
          ...prev,
          age: null,
        }));
        return;
      }
      // value.min = new Date(Math.abs(value.min - todayYear),0,1);
      // value.max = new Date(Math.abs(value.max - todayYear),11,1);
      setState((prev) => ({
        ...prev,
        age: {...value},
      }));
      return;
    }
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdateCheckbox = (e, value) => {
    const isChecked = e.target.checked;
    setState({ ...state, gender: isChecked ? value : "" });
  };

  /**
   * This method will search filestone
   */
  const onSearch = (e) => {
    e.preventDefault();
    dispatch({ type: REFRESH_SEARCH_PROFILE, payload: [] });
    setSort('asc');
  };

  /**
   * This method will search milestone
   */
  const getResults = async () => {
    if (isRequesting || !loadMore) return;

    dispatch({
      type: GET_SEARCH_PROFILE,
      payload: [],
    });

    // let formData = new FormData;

    // formData.append("page", page);
    // formData.append("keyword", JSON.stringify(search))

    // Object.keys(state).map(k => {
    //   formData.append(k, state[k]);
    // })
    const cleanedText = search.replace(/\s+/g, ' ').trim();
    let profType = state?.profileTypes === "all" ? null : state?.profileTypes;
    let jobRole = state?.job_role === "all" ? null : state?.job_role;
    let params = isAdvance ? {
      page: page,
      keyword: JSON.stringify(cleanedText),
      show_adult: userData?.profile?.show_adult || 0,
      ...state,
      age:JSON.stringify(state.age),
      profileTypes: profType,
      job_role: jobRole,
    }:
    {
      page: page,
      name:state?.name,
      keyword: JSON.stringify(cleanedText),
      show_adult: userData?.profile?.show_adult || 0,
    };



    try {
      const url = await urlSerializer("public/profiles/search", params);
      const response = await http.get(url);
      const { data } = response.data;
      const _page = data.length > 0 ? parseInt(page) + 1 : page;
      const _loadMore = data.length > 0 ? true : false;
      dispatch({
        type: SET_SEARCH_PROFILE,
        payload: { data: data, page: _page, loadMore: _loadMore, sort:sort },
      });
    } catch (err) {
      console.log("error@getResults", err);
      throw err;
    }
  };

  const getOccupations = async()=>{
    try{
      const {data} = await http.get("public/occupationsList");
      let occp = data.map(item =>{
        return{
          ...item,
          value:item.name,
          label:(item?.name).charAt(0).toUpperCase() + item?.name.slice(1),

        }
      });
      setOccupation(occp)
    }catch(e){
      console.log(e)
    }
  }

  /**
   * This method handle on scroll event
   */
  const handleScroll = () => {
    if (contentRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      const middleThreshold = scrollHeight / 3;
      const topClientHeight = scrollTop + clientHeight;
      if (topClientHeight >= middleThreshold) {
        getResults();
      }
    }
  };

  const handleAddressChange = (fieldName, addressValue) => {
      setState((prev) => ({
        ...prev,
        [fieldName]: addressValue,
      }));
    };

  useEffect(() => {
    setSearch(searchValue);

    if (searchValue) {
      dispatch({
        type: REFRESH_SEARCH_PROFILE,
        payload: [],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  /**
   * This effect will run on initialization of component
   * run again refresh value is change
   */
  useEffect(() => {
    if (initialize) {
      getResults();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, initialize]);

  useLayoutEffect(() => {
    gsap.fromTo(
      ".searchbar",
      {
        x: -20,
        opacity: 0,
      },
      {
        x: 0,
        opacity: 1,
      }
    );
    gsap.fromTo(
      ".searchbar-buttons",
      {
        x: 20,
        opacity: 0,
      },
      {
        x: 0,
        opacity: 1,
      }
    );
    // gsap.fromTo(
    //   ".search-title",
    //   {
    //     y: -20,
    //     opacity: 0,
    //   },
    //   {
    //     y: 0,
    //     opacity: 1,
    //   }
    // );
    gsap.fromTo(
      ".search-item",
      {
        x: 50,
        opacity: 0,
      },
      {
        x: 0,
        opacity: 1,
      }
    );
  }, []);

  useEffect(()=>{
    getOccupations();
    setIsAdvance(false)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const sortHandler = (e)=>{
    const { value } = e.target;
    setSort(value);
    let data = results;
    if (value === 'asc') {
      data = results.sort((a, b) => a.profile_name.localeCompare(b.profile_name));
    } else {
      data = results.sort((a, b) => b.profile_name.localeCompare(a.profile_name));
    }
    dispatch({
        type: SET_SORT_PROFILE,
        payload: { data: data, sort:value },
      });
  }

  return (
    <Layout
      title="Search"
      contentRef={contentRef}
      handleScroll={handleScroll}
      containerStyle="lg:static lg:overflow-y-auto lg:overflow-x-hidden">
      <div className="auth-page-wrapper pt-15">
        <div className="w-full container-max-width relative">
          {
            isAdvance && 
            <div className="absolute top-0 right-0 font-normal z-[9990]">
              <PopInfo type="advance_search" direction={`right`}
              responsive={{
                left: "6px",
                right: "6px",
              }}
              />
            </div>
          }
          <form onSubmit={onSearch}>
            <div className="w-full flex space-x-7.5 items-end relative">
              <div className="searchbar w-full 2md:w-11/20 lg:w-12/20">
                <Input
                  outsideLabel={isAdvance && 'Search Profile or Name'}
                  outsideLabelClass="text-sm font-bold text-darkerGray"
                  inputContainerClass="flex-1"
                  value={search}
                  name="search"
                  placeholder={t('search')}
                  noLabelPaddingY="1rem"
                  type="text"
                  onChange={handleSearchChange}
                />
              </div>
              <div className="w-9/20 3sm:w-6/20 4sm:w-4/20 1md:w-3/20 2md:w-9/20 lg:w-8/20">
                <div className="searchbar-buttons w-full flex space-x-3.5">
                  <Button
                    type="submit"
                    buttonName={
                      <span className="hidden 2md:block">{t('search')}</span>
                    }
                    buttonTextClass="text-sm text-white font-semibold flex items-center justify-center"
                    buttonRadius="6px"
                    iconPosition="left"
                    icon={<FaSearch className="2md:mr-3" />}
                    buttonClass="relative py-5.5 px-5.5 2md:py-4.5 2md:w-full bg-primary hover:bg-darkPrimary"
                  />
                  <Button
                    type="button"
                    buttonName={
                      <span className="hidden 2md:block">{`${
                        showAdvanceSearch ? t('close') : ""
                      } ${t('advancedSearch')}`}</span>
                    }
                    buttonTextClass="text-sm text-white font-semibold flex items-center justify-center"
                    buttonRadius="6px"
                    iconPosition="left"
                    icon={
                      showAdvanceSearch ? (
                        <FaTimes className="2md:mr-3" />
                      ) : (
                        <FaPlus className="2md:mr-3" />
                      )
                    }
                    buttonClass="relative py-5.5 px-5.5 2md:py-4.5 2md:w-full bg-lightBlack hover:bg-lightBlack/95"
                    onClick={() => {setShowAdvanceSearch((prev) => !prev); setIsAdvance(!isAdvance)}}
                  />
                </div>
              </div>
            </div>
          </form>
          {/* advance search forms */}
          <AdvanceSearch
            open={showAdvanceSearch}
            state={state}
            handleInputChange={handleInputChange}
            handleUpdateGender={handleUpdateCheckbox}
            handleAddressChange={handleAddressChange}
            occupations={[{label:'All', value:'all'}, ...occupations]}
          />
          {/* end: advance search forms */}
        </div>
        {/* search result */}
        <div className="w-full container-max-width mt-15">
          {
            results.length >0 &&
            <div className="flex justify-between items-start 2sm:items-center flex-col 2sm:flex-row">
              <div className="w-full flex flex-row gap-x-2 items-center">
                <h1 className="text-3xl font-bold tracking-tighter leading-9 text-lightBlack">
                  {t('seeAllResults')}
                </h1>
                <PopInfo type="search_all_result"  
                direction="left"
                //  onClickCallBack={() => setOverflow("overflow-visible")}
                />
              </div>
              <div className="w-full 2sm:w-auto">
                <Select
                  value={
                      sort &&
                      sortBy.filter((pt) => pt.value === sort)
                    }
                  formContainer="w-full lg:w-64"
                  options={sortBy}
                  height={40}
                  placeholder={t('select')}
                  name="sort"
                  label={"Sort by"}
                  innerLabelClass="text-1xs 3md:text-xs font-semibold color-select-label leading-3.5 absolute left-4.5 top-3 3md:top-4"
                  onChange={(e) =>
                    sortHandler({
                      target: { name: "sort", value: e.value },
                    })
                  }
                  isMulti={false}
                  valueContainerClass = "-10px !important"
                />
              </div>
            </div>
          }

          <div className="search-item w-full mt-12.5">
            {results.map((obj, index) => {
              // const fullName = obj.user
              //   ? `${obj.user.first_name} ${obj.user.last_name}`
              //   : null;
              // let occupations = !_.isEmpty(obj.occupations)
              //   ? listFormat(obj.occupations)
              //   : null;
              // let occupations = obj.occupations;
              // if (typeof obj.occupations === "string") {
              //   occupations = !_.isEmpty(obj.occupations)
              //     ? listFormat(obj.occupations)
              //     : null;
              // }

              return (
                <SearchItem
                  key={index}
                  data={obj}
                  keyword={state?.name || search}
                  image={obj.profile_image_webp_url || obj.profile_image_url || ProfileDefaultPlaceholder}
                  onProfileClick={(url) => history.push(url)}
                  // name={fullName}
                  // address={obj.address}
                  // work={occupations}
                  // showAdult={obj.show_adult ? true : false}
                />
              );
            })}
            <LoadMore
              result={results.length > 0 ? true : false}
              requesting={isRequesting}
              {...{
                initialize,
                loadMore,
              }}
            />
            {
              (!isRequesting && results.length <= 0) &&
              // <p>No profile found</p>
              <div className="h-[60vh] flex items-center justify-center bg-white rounded-md">
                <div className="flex flex-col items-center justify-center">
                  <img src={EmptySearch} alt="empty search" />
                  <p className="font-semibold">{t('NoResultsFound')}</p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </Layout>
  );
}

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};
